<template>
  <vs-popup
    id="stockTransferDetailPopup"
    :active.sync="isActive"
    v-esc="escape"
    :title="
      (transferLogs.stock ? transferLogs.stock.name : '') +
      ' - Transfer Geçmişi'
    "
  >
    <vs-row vs-type="flex" vs-w="12">
      <vs-row vs-type="flex" vs-w="12" class="mb-3">
        <global-filter
          ref="filterer"
          :tableOptions="tableOptions"
          :filterOptions="filterOptions"
          :filterChips="filterChips"
          :filterOptionNames="filterOptionNames"
          :isActive="isFilterActive"
          @saveOptions="saveOptions"
          @close="isFilterActive = false"
        />
        <vs-row
          id="panelHeaderRow"
          v-show="!isFilterActive"
          vs-type="flex"
          vs-w="12"
          vs-justify="space-between"
        >
          <vs-col
            id="panel-actions"
            vs-type="flex"
            class="w-auto"
            vs-justify="center"
          >
            <vs-row vs-type="flex" vs-w="12">
              <vs-col vs-type="flex" class="w-auto">
                <vx-tooltip text="Detaylı Filtereleme" position="top">
                  <vs-button
                    @click="isFilterActive = !isFilterActive"
                    class="panel-action text-warning xlarge-button panel-action-box-shadow"
                    color="transparent"
                    icon-pack="pickicon"
                    icon="icon-pick-filter"
                  >
                  </vs-button>
                </vx-tooltip>
              </vs-col>
              <vs-col vs-type="flex" class="w-auto">
                <vx-tooltip text="Excel Export" position="top">
                  <vs-button
                    @click="getExcel"
                    class="panel-action text-dark xlarge-button panel-action-box-shadow"
                    color="transparent"
                    icon-pack="feather"
                    icon="icon-download"
                  >
                  </vs-button>
                </vx-tooltip>
              </vs-col>
            </vs-row>
          </vs-col>
          <vs-col id="filter-chips" vs-type="flex">
            <vs-row
              vs-type="flex"
              vs-w="12"
              vs-justify="center"
              vs-align="center"
            >
              <vs-button
                id="clearFilterButton"
                v-if="filterChips.length > 0"
                @click="clearFilter"
                class="mr-2 bg-white text-danger panel-action-box-shadow"
                icon-pack="feather"
                icon="icon-slash"
                radius
                color="transparent"
              />
              <vs-col
                vs-type="flex"
                class="w-auto"
                v-for="(chip, index) in filterChips"
                :key="index"
              >
                <vs-chip
                  color="white"
                  class="panel-action-box-shadow px-1"
                  @click="removeFilter(chip.col, index)"
                  v-show="chip.value != ''"
                  closable
                >
                  <vs-row vs-tpye="flex" vs-w="12">
                    <vs-col vs-tpye="flex" class="w-auto" vs-align="center">
                      <span class="bold text-xsmaller text-dark">
                        {{ chip.name + " :" }}
                      </span>
                    </vs-col>
                    <vs-col
                      vs-type="flex"
                      class="w-auto ml-1"
                      vs-align="center"
                    >
                      <span
                        class="weight-600 italic text-xsmaller text-primary"
                      >
                        {{ chip.value }}
                      </span>
                    </vs-col>
                  </vs-row>
                </vs-chip>
              </vs-col>
            </vs-row>
          </vs-col>
          <vs-col
            id="table-page-size"
            vs-type="flex"
            class="w-auto"
            vs-justify="flex-end"
          >
            <vs-dropdown
              vs-trigger-click
              class="bg-white cursor-pointer panel-action-box-shadow"
            >
              <div
                class="px-4 d-theme-border-grey-light d-theme-dark-bg cursor-pointer flex items-center justify-between text-small"
              >
                <span class="mr-2 page-size-dropdown-span"
                  >{{ (currentPage + 1) * itemsPerPage - (itemsPerPage - 1) }}
                  -
                  {{
                    totalDataRow - (currentPage + 1) * itemsPerPage > 0
                      ? (currentPage + 1) * itemsPerPage
                      : totalDataRow
                  }}
                  of
                  {{ totalDataRow }}</span
                >
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
              </div>
              <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
              <vs-dropdown-menu>
                <vs-dropdown-item @click="itemsPerPage = 10">
                  <span>10</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage = 15">
                  <span>15</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage = 20">
                  <span>20</span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </vs-col>
        </vs-row>
      </vs-row>
      <vs-row vs-type="flex" vs-w="12" class="px-2 mb-2" v-if="transferLogs.logs">
        <p class="text-xs text-muted m-0">
          Miktarlar hammadde <strong>temel birim</strong>indedir.
          <strong>Bu Ay Eklenen</strong> ilgili sayım ayında stoka giren (Enter) toplamıdır; geçmiş sayımlar o anki hesapla kayıtlıdır.
        </p>
      </vs-row>
      <vs-row vs-type="flex" vs-w="12" v-if="transferLogs.logs">
        <vs-col
          class="sale-box-shadow m-3 half-friendly-border"
          vs-type="flex"
          vs-w="3.75"
          v-for="(entry, index) in transferLogs.logs.items"
          :key="index"
        >
          <vs-row vs-type="flex" vs-w="12">
            <vs-row vs-type="flex" vs-w="12" class="half-friendly-border">
              <span
                class="w-full straight-border sale-box-shadow bg-white text-center text-medium-small2 text-primary py-2 bold"
              >
                {{ entry.created }}
              </span>
            </vs-row>
            <vs-row vs-type="flex" vs-w="12" class="mt-3">
              <vs-col class="cartDetailValueCols" vs-type="flex" vs-w="3">
                <vs-row vs-type="flex" vs-w="12">
                  <vs-row vs-type="flex" vs-w="12">
                    <span
                      class="w-full text-center text-small text-primary weight-600"
                    >
                      Önceki Ay Devir
                    </span>
                  </vs-row>
                  <vs-row vs-type="flex" vs-w="12">
                    <span
                      class="w-full text-center p-1 overflow-dots text-medium bold text-dark"
                    >
                      {{ entry.preTransfer }}
                    </span>
                  </vs-row>
                </vs-row>
              </vs-col>
              <vs-col class="cartDetailValueCols" vs-type="flex" vs-w="3">
                <vs-row vs-type="flex" vs-w="12">
                  <vs-row vs-type="flex" vs-w="12">
                    <span
                      class="w-full text-center text-small text-primary weight-600"
                    >
                      Bu Ay Eklenen
                    </span>
                  </vs-row>
                  <vs-row vs-type="flex" vs-w="12">
                    <span
                      class="w-full text-center p-1 overflow-dots text-medium bold text-dark"
                    >
                      {{ entry.currentSaved }}
                    </span>
                  </vs-row>
                </vs-row>
              </vs-col>
              <vs-col class="cartDetailValueCols" vs-type="flex" vs-w="3">
                <vs-row vs-type="flex" vs-w="12">
                  <vs-row vs-type="flex" vs-w="12">
                    <span
                      class="w-full text-center text-small text-primary weight-600"
                    >
                      Ay Sonu Kalan
                    </span>
                  </vs-row>
                  <vs-row vs-type="flex" vs-w="12">
                    <span
                      class="w-full text-center p-1 overflow-dots text-medium bold text-dark"
                    >
                      {{ entry.currentLeft }}
                    </span>
                  </vs-row>
                </vs-row>
              </vs-col>
              <vs-col class="cartDetailValueCols" vs-type="flex" vs-w="3">
                <vs-row vs-type="flex" vs-w="12">
                  <vs-row vs-type="flex" vs-w="12">
                    <span
                      class="w-full text-center text-small text-primary weight-600"
                    >
                      Aylık Tüketim
                    </span>
                  </vs-row>
                  <vs-row vs-type="flex" vs-w="12">
                    <span
                      class="w-full text-center p-1 overflow-dots text-medium bold text-dark"
                    >
                      {{ entry.currentConsume }}
                    </span>
                  </vs-row>
                </vs-row>
              </vs-col>
            </vs-row>
            <vs-row
              vs-type="flex"
              vs-w="12"
              vs-align="center"
              vs-justify="space-between"
              class="straight-border mt-3 bg-white p-2"
            >
              <vs-col
                vs-type="flex"
                vs-w="5.5"
                vs-justify="flex-end"
                class="straight-bordert"
              >
                <span class="weight-600 text-primary"> Değer : </span>
              </vs-col>
              <vs-col vs-type="flex" vs-w="5.5">
                <span
                  class="product-category text-center"
                  :class="{ 'text-danger': entry.resultValue != 0 }"
                >
                  <p class="bold text-medium" v-if="entry.resultValue != 0">
                    {{
                      entry.resultValue > 0
                        ? "+ " + entry.resultValue
                        : entry.resultValue
                    }}
                  </p>
                  <feather-icon
                    v-else
                    icon="CheckIcon"
                    style="color: green; width: 2.5rem; height: 2.5rem"
                  />
                </span>
              </vs-col>
            </vs-row>
          </vs-row>
        </vs-col>
      </vs-row>
      <pagination-default
        :totalLenght="calculatePageLength"
        :setCurrentPage="tableOptions.pageIndex"
        @currentPage="getCurrentPage"
      ></pagination-default>
    </vs-row>
  </vs-popup>
</template>

<script>
import PaginationDefault from "@/views/pages/PaginationDefault";
import GlobalFilter from "@/views/pages/GlobalFilter";
import {
  getStockTransferHistory,
  getStockHistoryExcel,
} from "@/api/MonthlyStockTransfer";
export default {
  data() {
    return {
      isActive: false,
      transferLogs: {
        logs: null,
        stock: null,
      },
      stockId: null,

      totalDataRow: 0,
      tableOptions: {},
      currentPage: 0,
      itemsPerPage: 10,

      isFilterActive: false,
      filterChips: [],
      filterOptions: [
        "dateRange",
        "timeRange",
        "rangePreTransfer",
        "rangeCurrSaved",
        "rangeCurrConsume",
        "rangeCurrLeft",
        "rangeNumber",
      ],
      filterOptionNames: [
        "Tarih",
        "Zaman",
        "Yıl",
        "Önceki Trans.",
        "Bu Ay Kayıt",
        "Bu Ay Harcan.",
        "Bu Ay Kalan",
        "Sonuç",
      ],
    };
  },
  components: {
    PaginationDefault,
    GlobalFilter,
  },
  computed: {
    calculatePageLength() {
      let mod = this.totalDataRow % this.itemsPerPage;
      return mod > 0
        ? (this.totalDataRow - mod) / this.itemsPerPage + 1
        : this.totalDataRow / this.itemsPerPage;
    },
  },
  methods: {
    getExcel() {
      getStockHistoryExcel(this.tableOptions, this.stockId)
        .then((res) => {
          if (res && res.status === 200) {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute(
              "download",
              this.transferLogs.stock.name + " Envanter Raporu" + ".xlsx"
            );
            document.body.appendChild(link);
            link.click();

            this.$vs.notify({
              color: "success",
              title: "Başarılı",
              text: "Excel Export Başarılı !",
            });
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Excel Export İşlemi Başarısız !",
            });
          }
        })
        .catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !",
          });
        });
    },
    clearFilter() {
      this.tableOptions = {
        sortBy: "Created",
        sortDirection: "desc",
        pageIndex: 0,
        pageSize: 10,
        stock: null,
        dateRange: {
          startDate: null, //this.$now.date().toString(),
          endDate: null, //this.$now.date().toString(),
        },
        timeRange: {
          startTime: null,
          endTime: null,
        },
        rangePreTransfer: {
          min: null,
          max: null,
        },
        rangeCurrSaved: {
          min: null,
          max: null,
        },
        rangeCurrConsume: {
          min: null,
          max: null,
        },
        rangeCurrLeft: {
          min: null,
          max: null,
        },
        rangeNumber: {
          min: null,
          max: null,
        },
      };
      this.filterChips.length = 0;
    },
    saveOptions(filterOptions, filterChips) {
      filterChips = filterChips.filter((x) => x.name != undefined);
      this.isFilterActive = false;
      if (_.isEqual(this.tableOptions, filterOptions)) return;
      this.tableOptions = _.cloneDeep(filterOptions);
      this.filterChips = _.cloneDeep(filterChips);
    },
    removeFilter(col, index) {
      if (col === "branch") this.tableOptions[col] = this.$currentUser.branch;
      else this.tableOptions[col] = "";
      this.filterChips.splice(index, 1);
    },
    getCurrentPage(currentx) {
      this.currentPage = currentx - 1;
    },
    escape() {
      if (this.isActive == true) this.isActive = false;
    },
    getStockTransferHistory() {
      getStockTransferHistory(this.tableOptions, this.stockId)
        .then((res) => {
          if (res && res.status === 200) {
            this.transferLogs = res.data;
            this.totalDataRow = res.data.logs.totalCount;
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Transfer Geçmişi Yüklenemedi !",
            });
          }
        })
        .catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !",
          });
        });
    },
  },
  watch: {
    isActive(val) {
      if (!val) return;
      this.clearFilter();
    },
    tableOptions: {
      deep: true,
      handler() {
        this.$nextTick(() => {
          this.getStockTransferHistory();
        });
      },
    },
    currentPage: function (val) {
      this.tableOptions.pageIndex = val;
    },
    itemsPerPage: function (val) {
      this.currentPage = 0;
      this.tableOptions.pageSize = val;
    },
  },
};
</script>

<style>
#stockTransferDetailPopup .vs-popup {
  width: 90% !important;
}

.cartDetailValueCols {
  border-right: 0.5px solid #6a1f13;
}

.cartDetailValueCols:last-child {
  border: none !important;
}

#stockTransferDetailPopup .vs-popup .vs-popup--content {
  background: transparent linear-gradient(147deg, #f8f8f8 0%, #f1f1f1 100%) 0%
    0% no-repeat padding-box;
  margin: 0;
  padding: 1rem;
  width: 100% !important;
}

#stockTransferDetailPopup .vs-popup .vs-popup--header {
  background: #ffffff 0% 0% no-repeat padding-box;
  color: #6a1f13;
  font-weight: 600;
}

#stockTransferDetailPopup .vs-popup .vs-popup--header div h3 {
  color: #6a1f13;
  font-weight: 600;
}
</style>
